import { Epic, StateObservable, ofType } from 'redux-observable';
import { Action, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '@store/create-store';
import { Dependencies } from '@configurations/dependencies/dependencies';
import { Observable, catchError, concatMap, from, mergeMap, of } from 'rxjs';
import {
  downloadPriceCardFileFailure,
  downloadPriceCardFileSuccess,
} from '@store/price-card/price-card-file/price-card-file.slice';
import { displayToast } from '@store/toast-notifications/toast-notifications-slice';
import { ToastNotification } from '@scenario/models/toast-notification.model';

export type DownloadPriceCardFilePayload = {
  priceZoneId: number;
  technologyId: number;
  commercialOperationDateIds: number[];
}

export const downloadPriceCardFileEpic: Epic<Action, Action, RootState, Dependencies> = (
  action$: Observable<Action>,
  _state$: StateObservable<RootState>,
  dependencies: Dependencies,
) =>
  action$.pipe(
    ofType('priceCardFile/downloadPriceCardFile'),
    concatMap((action: PayloadAction<DownloadPriceCardFilePayload>) =>
      from(dependencies.priceCardFileGateway.retrieveByPriceZoneAndTechnologyAndCommercialOperationDate(action.payload.priceZoneId, action.payload.technologyId, action.payload.commercialOperationDateIds)).pipe(
        mergeMap(() => {
          const toastNotification: ToastNotification = {
            title: 'Download Price Card File',
            content: 'The price card file has been downloaded successfully',
            status: 'info',
            closeIconButtonLabel: 'close',
            reference: dependencies.idProvider.generate(),
          };
          return of(downloadPriceCardFileSuccess(), displayToast(toastNotification));
        }),
        catchError(() => {
          const toastNotification: ToastNotification = {
            title: 'Download Price Card File',
            content: 'Enable to download your price card',
            status: 'danger',
            closeIconButtonLabel: 'close',
            reference: dependencies.idProvider.generate(),
          };
         return of(downloadPriceCardFileFailure('Fail to download price card file'), displayToast(toastNotification));
        }),
      ),
    ),
  );
